<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link class="blue-grey-text text-darken-4 strong"
                     :to="instrumentId ? '/tickeradmin/listcompanies' : portfolioId ? '/tickeradmin/listservices': ''"
        >
          Security Master:
          {{ instrumentId ? 'Companies' : portfolioId ? 'Services': '' }}
        </router-link>
        >
        <router-link :to="`/tickeradmin/viewinstrument?instrument_id=${recommendations[0].instrument.id}`"
                     class="blue-grey-text text-darken-4 strong"
                     v-if="instrumentId && recommendations.length"
        >
          View Instrument
        </router-link>
        <router-link :to="`/tickeradmin/viewportfolio?portfolio_id=${recommendations[0].portfolio.id}`"
                     class="blue-grey-text text-darken-4 strong"
                     v-if="portfolioId && recommendations.length"
        >
          View Portfolio
        </router-link>
        >
        <span>View Recommendations</span>
      </section>
    </article>
    <section class="col s4 left-align">
      <h4>View Recommendations</h4>
      <h5>
        Allocation Total:&nbsp;
        <span :class="totalAllocation <= 100 ? 'teal-text' : 'pink-text'">
          {{ totalAllocation }}%
        </span>
        Cash:&nbsp;
        <span class="teal-text">{{ 100 - totalAllocation }}%</span>
      </h5>
      <h6>
        <i>Pending recs in gray will not show up on website and will remain pending until the article is published. If you need to edit these recs before the publish date, please contact #investing-tech-help.</i>
      </h6>
    </section>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Instrument</th>
          <th>Portfolio</th>
          <th>Slug</th>
          <th>Allocation Goal %</th>
          <th>Open Date</th>
          <th>Close Date</th>
          <th v-show="$auth.hasRoles('admin', 'recs-admin')" />
        </tr>
      </thead>
      <tbody>
        <tr :class="[recommendation.is_pending ? 'pending-rec' : '' ]" v-for="recommendation in recommendations" :key="recommendation.recommendation_uuid">
          <td v-if="recommendation.is_pending">PENDING</td>
          <td v-else>#{{ recommendation.id }}</td>
          <td>{{ recommendation.instrument.ticker || recommendation.instrument.asset_class.toUpperCase() + ':' + recommendation.instrument.symbol}}</td>
          <td>{{ recommendation.portfolio.name }}</td>
          <td>{{ recommendation.portfolio.slug }}</td>
          <td>
            <input placeholder="0"
                   type="number"
                   class="validate"
                   min="0"
                   max="100"
                   :value="recommendation.allocation_percentage_goal"
                   @blur="updated(recommendation, $event)"
                   v-if="$auth.hasRoles('admin', 'recs-admin', 'analyst')"
            >
            <span v-else>{{ recommendation.allocation_percentage_goal }}</span>
          </td>
          <td>{{ recommendation.open_date }}</td>
          <td>{{ recommendation.close_date || '-' }}</td>
          <td>
            <router-link :to="`/tickeradmin/editrec?recommendation_id=${recommendation.id}`"
                         v-show="$auth.hasRoles('admin', 'recs-admin')"
                         v-if="!recommendation.is_pending"
            >
              <i class="far fa-edit clickable amber-text big" />
            </router-link>
            <i
              class="fas fa-info-circle clickable blue-text big"
              title="Pending recs will remain pending until the article is published. If you need to edit this rec before the publish date, please contact #investing-tech-help."
              v-else
            />
          </td>
        </tr>
      </tbody>
    </table>
    <aside class="usm-add-recommendation-aside" v-show="$auth.hasRoles('admin', 'recs-admin')">
      <router-link to="/tickeradmin/addrecommendation">
        <button class="btn-large btn-floating waves-effect waves-light teal accent-4">
          <i class="fas fa-plus" />
        </button>
        <label>Add Rec</label>
      </router-link>
    </aside>
    <article class="row" v-show="waiting">
      <section class="col s12 progress amber accent-1">
          <aside class="indeterminate amber accent-3" />
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TickerAdminViewRecommendations',
  data() {
    return {
      recommendations: [],
      waiting: false,
    };
  },
  computed: {
    instrumentId() {
      return Number(this.$route.query.instrument_id) || 0;
    },
    portfolioId() {
      return Number(this.$route.query.portfolio_id) || 0;
    },
    totalAllocation() {
      return this.recommendations.map(rec => rec.allocation_percentage_goal).reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    async fetchRecommendations() {
      let url = `${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/recommendations/?include_pending=true&`;
      if (this.instrumentId) { url += `instrument_id=${this.instrumentId}`; }
      if (this.portfolioId) { url += `portfolio_id=${this.portfolioId}`; }
      this.waiting = true;
      const { data } = await axios.get(url);
      this.recommendations = data;
      this.sortArray(this.recommendations, 'is_pending', true);
      this.waiting = false;
    },
    async updated(recommendation, evt) {
      const allocationUpdate = Number(evt.target.value);
      if (allocationUpdate < 0) {
        return this.toast('Allocation percentage needs to be >= 0', 'pink');
      }

      const updatedRec = this.recommendations.filter(r => r.id === recommendation.id)[0];
      const allocationDelta = allocationUpdate - updatedRec.allocation_percentage_goal;

      if (this.totalAllocation + allocationDelta > 100) {
        return this.toast('Total Allocation Percentage is over 100', 'pink');
      }

      await axios.put(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/recommendation/?recommendation_id=${recommendation.id}`, {
        analyst_id: this.$auth.user.pk,
        recommendation_id: recommendation.id,
        instrument_id: recommendation.instrument.id,
        portfolio_id: recommendation.portfolio.id,
        open_date: recommendation.open_date,
        allocation_percentage_goal: allocationUpdate,
      });
      updatedRec.allocation_percentage_goal = allocationUpdate;
      return this.toast(`Saved ${recommendation.id}`, 'green');
    },
  },
  mounted() {
    this.fetchRecommendations();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.usm-add-recommendation-aside {
  position: absolute;
  top: 25px;
  right: 30px;
  & label {
    display: block;
    margin-top: 5px;
  }
}

.pending-rec {
  background: #ccc;
}
</style>
